module.exports = __webpack_public_path__ + "static/dashboard-premium-1-47c9c83f34bb0a973255f237b3d230ef.png";